import styled from "styled-components";

export const ChangePhoneContainer = styled.div`
  width: 100%;
  align-items: flex-start;
  display: flex;
  gap: 21px;

  .phone-col {
    padding: 0px 21px 0px 0px;
  }
  .change-phone-row {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    gap: 15px;
  }
  form {
    width: 290px;

    &.phone-form {
      width: 100%;
      .form-error {
        margin-top: 10px;
      }
      .control {
        display: flex;
        gap: 20px;
        align-items: center;
        width: 100%;
      }

      .react-tel-input {
        display: flex;
        width: 100%;

        .flag-dropdown {
          padding: 10px 4px;
          margin-bottom: 0px;
          background-color: transparent;
          border-right: 1px solid ${({ theme }) => theme.card.border.quaternary};
          border-left: 0px;
          border-top: 0px;
          border-bottom: 0px;
        }
      }

      .phone-form-field {
        padding: 10px 15px 10px 55px;
        background-color: transparent;
        border: 1px solid ${({ theme }) => theme.card.border.quaternary};
        min-width: 200px;
        flex-grow: 1;
        display: flex;
      }
    }

    .code-input {
      display: flex;
      align-items: center;
      min-width: 152px;
      position: relative;

      .form-error {
        position: absolute;
        top: 59px;
        left: 10px;
      }
    }

    &.code-form {
      gap: 21px;
      align-items: flex-end;

      .form-error {
        margin-top: 10px;
      }
    }

    .verify-button-wrapper {
      display: flex;
      gap: 15px;
      height: 100%;
      justify-content: flex-end;
      align-items: flex-end;
      margin-top: -8px;

      .transparent-btn {
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        width: 50%;

        &.resend-btn {
          width: 50%;
        }

        .check {
          height: 24px;
          width: 12px;
          border-bottom: 4px solid #fff;
          border-right: 4px solid #fff;
          transform: rotate(45deg);
          margin: -3px 0px 0px;
          border-radius: 2px;
        }
      }

      .resend-btn {
        flex-grow: 1;
        height: auto;
      }

      .resend-seconds {
        width: auto;
        text-wrap: nowrap;
      }

      button {
        width: 100%;
        width: 97px;
      }
    }

    .form-control {
      margin-bottom: 1rem;
    }

    .button-small {
      min-width: 75px;
    }
  }

  @media screen and (max-width: 768px) {
    .phone-col {
      padding-right: 0px;
    }

    form {
      &.code-form {
        width: 100%;
        margin: 0px 0px 25px 0px;
      }
    }
  }

  @media screen and (max-width: 430px) {
    form {
      &.code-form {
        flex-direction: column;
      }

      .code-input {
        .input-form {
          width: 100%;
        }
      }
    }
  }

  @media (max-width: 1100px) {
    .phone-col {
      width: 100%;
      margin-bottom: 25px;
    }
  }
`;
